import React, { useState, useEffect, useRef } from 'react';
import ContactFormModal from './ContactFormModal';

const HireMeToSpeakSection = ({
  title = "Let's Co-Create",
  imageSrc = "/Herro_logo.jpg",
  paragraphs = [
    "Yomuma Likessa is an entrepreneur, business coach, and co-founder with a proven track record of success. Starting from the ground up, he has mentored and guided startups and MSMEs to achieve sustainable growth and innovation.",
    "Through hands-on experience and collaboration with industry leaders, Yomuma has developed expertise in fostering talent, creating strategic partnerships, and driving impactful results for businesses and development partners."
  ],
  tags = "Entrepreneurship | Business Growth",
  buttonText = "Let's Co-Create",
  onButtonClick,
  formspreeEndpoint = 'https://formspree.io/f/xnnlqqpv',
  autoOpenModal = false
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const sectionRef = useRef(null);
  const hasAutoOpenedRef = useRef(false);

  // Auto-open modal when autoOpenModal prop is true
  useEffect(() => {
    if (autoOpenModal) {
      // Small delay to ensure smooth scroll completes
      const timer = setTimeout(() => {
        setIsModalOpen(true);
        hasAutoOpenedRef.current = true;
      }, 800);
      return () => clearTimeout(timer);
    } else {
      // Reset when prop becomes false to allow re-triggering
      hasAutoOpenedRef.current = false;
    }
  }, [autoOpenModal]);

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div ref={sectionRef} className="bg-white py-16 lg:py-20 w-full relative overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 lg:px-8 relative">
        <div className="flex flex-col lg:flex-row items-center lg:items-start relative">
          {/* Left Section - Yellow Background + Image */}
          <div className="w-full lg:w-1/2 relative z-0">
            {/* Yellow Background Block - Behind and slightly lower, extends forward */}
            <div className="absolute left-2 sm:left-4 lg:left-8 top-4 lg:top-8 bottom-4 sm:bottom-6 lg:bottom-8 right-0 lg:right-4 bg-accent-yellow z-0"></div>
            
            {/* Image Container - Overlaps the yellow background from above */}
            <div className="relative z-10 pl-4 sm:pl-6 lg:pl-12 mb-8 lg:mb-12">
              <img
                src={imageSrc}
                alt="Yomuma Likessa"
                className="w-full h-auto object-cover relative z-10"
              />
            </div>
          </div>

          {/* Right Section - Overlapping Card */}
          <div className="w-full lg:w-1/2 lg:absolute lg:right-0 lg:top-1/2 lg:transform lg:-translate-y-1/2 mt-8 lg:mt-0 z-20">
            <div className="bg-white rounded-lg shadow-xl p-6 sm:p-8 lg:p-12 lg:ml-[-120px] lg:mr-8">
              {/* Title */}
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4 text-center">
                {title}
              </h2>
              
              {/* Separator Lines */}
              <div className="flex flex-col items-center mb-6 space-y-1">
                <div className="w-24 h-0.5 bg-red-800"></div>
                <div className="w-20 h-1 bg-red-700"></div>
              </div>

              {/* Content Paragraphs */}
              <div className="space-y-4 mb-6">
                {paragraphs.map((paragraph, index) => (
                  <p key={index} className="text-gray-700 text-base lg:text-lg leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>

              {/* Tags */}
              <p className="text-gray-600 text-sm lg:text-base mb-8 text-center">
                {tags}
              </p>

              {/* Button */}
              <div className="flex justify-center">
                <button
                  onClick={handleButtonClick}
                  className="bg-accent-yellow text-gray-800 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-yellow-400 hover:scale-105 transition-all duration-200"
                >
                  {buttonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Modal */}
      <ContactFormModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        formspreeEndpoint={formspreeEndpoint}
      />
    </div>
  );
};

export default HireMeToSpeakSection;
